
export enum crownType {
    none = 'none',
    H = 'H',
    G = 'G',
}